// extracted by mini-css-extract-plugin
export default {"container":"bQ-z","title":"cQ-z","link":"dQ-z"};